export default __webpack_public_path__ + "static/media/E1.01cbf977.mp3";